export default __webpack_public_path__ + "static/media/tren_components_sound_sensor.8828c8b5.png";